import { http } from '../api/http';
import type { BlogPost, BlogCategory } from '../types/Blog';

export interface CreateCategoryDto {
  name: string;
  slug: string;
  parentId?: string | number | bigint | null;
  is_active?: boolean;
}

export interface UpdateCategoryDto {
  name?: string;
  parentId?: string | number | bigint | null;
  is_active?: boolean;
}

export interface CreatePostDto {
  authorId: string | number | bigint;
  title: string;
  slug: string;
  excerpt?: string | null;
  content?: string | null;
  coverImageUrl?: string | null;
  categoryIds?: (string | number | bigint)[];
  status?: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED';
  publishedAt?: string | null;
  is_active?: boolean;
}

export interface UpdatePostDto {
  title?: string;
  excerpt?: string | null;
  content?: string | null;
  coverImageUrl?: string | null;
  categoryIds?: (string | number | bigint)[];
  status?: 'DRAFT' | 'PUBLISHED' | 'ARCHIVED';
  publishedAt?: string | null;
  is_active?: boolean;
}

export const BlogService = {
  // Métodos públicos
  getPublicCategories() {
    return http<BlogCategory[]>('/blogs/categories', { auth: false });
  },

  getPublicPosts(params?: any) {
    const qs = new URLSearchParams(params || {}).toString();
    return http<BlogPost[]>(`/blogs${qs ? `?${qs}` : ''}`, { auth: false });
  },

  getPublicPostBySlugOrId(slugOrId: string) {
    return http<BlogPost>(`/blogs/${encodeURIComponent(slugOrId)}`, { auth: false });
  },

  getAdminPosts() {
    return http<BlogPost[]>('/admin/blogs');
  },

  getAdminPost(id: string | number) {
    return http<BlogPost>(`/admin/blogs/${id}`);
  },

  createPost(payload: any) {
    return http<BlogPost>('/admin/blogs', { method: 'POST', body: payload });
  },

  updatePost(id: string | number, payload: any) {
    return http<BlogPost>(`/admin/blogs/${id}`, { method: 'PUT', body: payload });
  },

  deletePost(id: string | number) {
    return http(`/admin/blogs/${id}`, { method: 'DELETE' });
  },

  getAdminCategories() {
    return http<BlogCategory[]>('/admin/blogs/categories');
  },

  createCategory(payload: CreateCategoryDto) {
    return http<BlogCategory>('/admin/blogs/categories', { method: 'POST', body: payload });
  },

  updateCategory(slug: string, payload: UpdateCategoryDto) {
    return http<BlogCategory>(`/admin/blogs/categories/${encodeURIComponent(slug)}`, { method: 'PUT', body: payload });
  },

  deleteCategory(slug: string) {
    return http(`/admin/blogs/categories/${encodeURIComponent(slug)}`, { method: 'DELETE' });
  }
};
